'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var SvgClass = {
  // Inefficient, inelegant nonsense for IE's svg element, which has no classList and non-HTML className implementation
  hasClass: function hasClass(el, className) {
    if (el.nodeType !== 1) {
      return false;
    }
    if (_typeof(el.classList) === 'object') {
      return el.nodeType === 1 && el.classList.contains(className);
    }
    var classNameSupported = typeof el.className === 'string';
    var elClass = classNameSupported ? el.className : el.getAttribute('class');
    return SvgClass.classNameContainsClass(elClass, className);
  },
  addClass: function addClass(el, className) {
    if (el.nodeType !== 1) {
      return;
    }
    if (_typeof(el.classList) === 'object') {
      el.classList.add(className);
    } else {
      var classNameSupported = typeof el.className === 'string';
      var elClass = classNameSupported ? el.className : el.getAttribute('class');
      if (elClass) {
        if (!SvgClass.classNameContainsClass(elClass, className)) {
          elClass += ' ' + className;
        }
      } else {
        elClass = className;
      }
      if (classNameSupported) {
        el.className = elClass;
      } else {
        el.setAttribute('class', elClass);
      }
    }
  },
  removeClass: function removeClass(el, className) {
    function replacer(matched, whiteSpaceBefore, whiteSpaceAfter) {
      return whiteSpaceBefore && whiteSpaceAfter ? ' ' : '';
    }

    if (el.nodeType !== 1) {
      return;
    }
    if (_typeof(el.classList) === 'object') {
      el.classList.remove(className);
    } else {
      var classNameSupported = typeof el.className === 'string';
      var elClass = classNameSupported ? el.className : el.getAttribute('class');
      elClass = elClass.replace(new RegExp('(^|\\s)' + className + '(\\s|$)'), replacer);
      if (classNameSupported) {
        el.className = elClass;
      } else {
        el.setAttribute('class', elClass);
      }
    }
  },
  classNameContainsClass: function classNameContainsClass(fullClassName, className) {
    return !!fullClassName && new RegExp('(?:^|\\s)' + className + '(?:\\s|$)').test(fullClassName);
  }
};